import "core-js/modules/es6.object.assign";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import _ from 'lodash';
import { htmlToReact, Link } from '../utils';
import Social from './Social';

var Footer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Footer.prototype;

  _proto.render = function render() {
    return React.createElement("footer", {
      id: "colophon",
      className: "site-footer"
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("div", {
      className: "site-footer-inside"
    }, React.createElement("p", {
      className: "site-info"
    }, htmlToReact(_.get(this.props, 'pageContext.site.siteMetadata.footer.content')), "\xA0", _.map(_.get(this.props, 'pageContext.site.siteMetadata.footer.links'), function (link, link_idx) {
      return React.createElement(React.Fragment, {
        key: link_idx
      }, React.createElement(Link, Object.assign({
        key: link_idx,
        to: _.get(link, 'url')
      }, _.get(link, 'new_window') ? {
        target: '_blank',
        rel: 'noopener'
      } : null), _.get(link, 'text')), ".");
    })), _.get(this.props, 'pageContext.site.siteMetadata.footer.has_social') && React.createElement(Social, this.props))));
  };

  return Footer;
}(React.Component);

export { Footer as default };